import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      text-align: center;\n\n      ", " {\n        text-align: center;\n      }\n\n      ", " {\n        border-top: 0;\n        display: block;\n        padding-bottom: 32px;\n        padding-top: 0;\n\n        > * {\n          display: block;\n          margin: auto;\n\n          &:nth-child(2) {\n            margin-top: 8px;\n          }\n        }\n      }\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  align-self: center;\n  background-color: ", ";\n  border-radius: 4px;\n  margin: auto;\n  max-height: 90vh;\n  max-width: ", ";\n  overflow: auto;\n  padding: 40px;\n  position: relative;\n  width: 100%;\n\n  &:focus {\n    outline: none;\n  }\n\n  ", ";\n\n  &-overlay {\n    background-color: rgba(0, 0, 0, 0.6);\n    display: flex;\n    height: 100%;\n    left: 0;\n    overflow-y: auto;\n    padding: 24px;\n    position: fixed;\n    top: 0;\n    width: 100%;\n    z-index: 2000;\n  }\n\n  &-bodyOpen {\n    overflow: hidden;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 16px;\n  top: 16px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: ", ";\n  border-top: 1px solid ", ";\n  display: flex;\n  flex-direction: row-reverse;\n  margin: 32px -40px -40px;\n  padding: 24px 40px;\n  border-radius: 0 0 4px 4px;\n\n  > *:nth-child(2) {\n    margin-right: 8px;\n  }\n\n  > *:nth-child(3) {\n    margin-right: auto;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  line-height: 1.4375; /* TODO: Typography */\n  margin: 0 0 24px 0;\n\n  ", " + & {\n    margin-top: -16px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 1.25; /* TODO: Typography */\n  margin: 0 0 24px 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
/* eslint-disable no-console */


import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import Button from '../Button/web/Button';
import * as colors from '../../styles/colors';
var ariaHideApp = true;
var rootElement = typeof document !== 'undefined' ? document.getElementById('root') : null;

if (rootElement) {
  ReactModal.setAppElement(rootElement);
} else {
  ariaHideApp = false;
}

export default function Modal(_ref) {
  var center = _ref.center,
      children = _ref.children,
      contentLabel = _ref.contentLabel,
      disableClose = _ref.disableClose,
      onRequestClose = _ref.onRequestClose,
      className = _ref.className,
      small = _ref.small,
      props = _objectWithoutProperties(_ref, ["center", "children", "contentLabel", "disableClose", "onRequestClose", "className", "small"]);

  var _useMemo = useMemo(function () {
    return React.Children.toArray(children).reduce(function (acc, child) {
      if (child.type === Modal.Heading) {
        acc.heading = child;
      } else if (child.type === Modal.Actions) {
        acc.actions = child;

        if (process.env !== 'production') {
          if (center && child.props.children.length > 2) {
            console.warn("Modal.Actions should not have more than 2 children when 'center' is true");
          } else if (child.props.children.length > 3) {
            console.warn('Modal.Actions should not have more than 3 children');
          }
        }
      } else {
        acc.content.push(child);
      }

      return acc;
    }, {
      heading: null,
      content: [],
      actions: null
    });
  }, [children]),
      heading = _useMemo.heading,
      content = _useMemo.content,
      actions = _useMemo.actions;

  if (process.env !== 'production') {
    if (!heading && !contentLabel) {
      console.warn('Modal should be provided a contentLabel as a replacement if a Modal.Heading is not rendered, for accessibility.');
    }
  }

  var labelledby = heading ? 'modal-heading' : null;
  return React.createElement(StyledModal, _extends({}, props, {
    aria: {
      labelledby: labelledby
    },
    extraClassName: className // Propagate extra className through to the styled component using this prop
    ,
    ariaHideApp: ariaHideApp,
    center: center,
    contentLabel: contentLabel,
    onRequestClose: onRequestClose,
    shouldCloseOnEsc: !disableClose,
    shouldCloseOnOverlayClick: !disableClose,
    small: small
  }), heading, content, actions, !disableClose && React.createElement(CloseButton, {
    "aria-label": "Close modal",
    onClick: onRequestClose,
    type: "text",
    color: "secondary",
    icon: "IconX",
    size: "small"
  }));
}

function ModalHeading(_ref2) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["children"]);

  return React.createElement(Heading, _extends({
    id: "modal-heading"
  }, props), children);
}

ModalHeading.propTypes = {
  children: PropTypes.node.isRequired
};

function ModalActions(_ref3) {
  var children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["children"]);

  return React.createElement(Actions, props, children);
}

ModalActions.propTypes = {
  children: PropTypes.node.isRequired
};
Modal.propTypes = _objectSpread({}, ReactModal.propTypes, {
  className: PropTypes.string,
  center: PropTypes.bool,
  disableClose: PropTypes.bool,
  small: PropTypes.bool
});
Modal.defaultProps = _objectSpread({}, ReactModal.defaultProps, {
  center: false,
  disableClose: false,
  small: false
});

var ReactModalAdapter = function ReactModalAdapter(_ref4) {
  var className = _ref4.className,
      extraClassName = _ref4.extraClassName,
      props = _objectWithoutProperties(_ref4, ["className", "extraClassName"]);

  return React.createElement(ReactModal, _extends({}, props, {
    className: "".concat(className, " ").concat(extraClassName),
    overlayClassName: "".concat(className, "-overlay"),
    bodyOpenClassName: "".concat(className, "-bodyOpen")
  }));
};

ReactModalAdapter.propTypes = {
  className: PropTypes.string.isRequired,
  extraClassName: PropTypes.string
};
ReactModalAdapter.defaultProps = {
  extraClassName: ''
};
var Heading = styled.h1(_templateObject());
var Subheading = styled.p(_templateObject2(), colors.steel, Heading);
var Actions = styled.div(_templateObject3(), colors.white, colors.mystic);
var CloseButton = styled(Button)(_templateObject4()); // We're exporting this so the documentation can keep the styles in sync

export var modalStyles = css(_templateObject5(), colors.white, function (_ref5) {
  var small = _ref5.small;
  return small ? '440px' : '640px';
}, function (_ref6) {
  var center = _ref6.center;
  return center && css(_templateObject6(), Heading, Actions);
});
var StyledModal = styled(ReactModalAdapter)(_templateObject7(), modalStyles);
Modal.Heading = ModalHeading;
Modal.Actions = ModalActions;
Modal.Subheading = Subheading;